import Rebase from 're-base'
import firebase from 'firebase/app'
import database from 'firebase/database'
import 'firebase/auth'

const app = firebase.initializeApp({
  apiKey: "AIzaSyAU476YoM2e823dpqiBrOzGuVvzf_Qr6gM",
  authDomain: "noteherder-a8543.firebaseapp.com",
  databaseURL: "https://noteherder-a8543.firebaseio.com",
  projectId: "noteherder-a8543",
  storageBucket: "noteherder-a8543.appspot.com",
  messagingSenderId: "698250713161"
})

const db = database(app)

export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const githubProvider = new firebase.auth.GithubAuthProvider()
export const auth = app.auth()

export default Rebase.createClass(db)



// WEBPACK FOOTER //
// ./src/base.js